//--------------------------------
// save current armour locations
//--------------------------------
export default function saveCurrentArmourLocations(armour_locations) {
  if (!Array.isArray(armour_locations)) {
    return []
  }

  return armour_locations.map((armour_location) => ({
    id: armour_location.id ?? null,
    armour_location_name: armour_location.armour_location_name || armour_location.name || '',
    hp_cur: armour_location.hp_cur ?? 0,
  }))
}
